import { DeviceIdentity } from './device.type';
import { PredefinedMessage } from './predefined-message.type';
import { RouteSummary } from './route-summary.type';

export type LoginCredentials = {
  pin: string;
  identity: DeviceIdentity;
  softwareVersion: string;
  buildVersion?: string;
  vehicleId: string;
}

export enum FareTypeEnum {
  NORMAL = 'NORMAL',
  BILLED = 'BILLED',
  BALANCE = 'BALANCE',
  EXTERNAL = 'EXTERNAL',
  ETICKET = 'ETICKET',
}

export type FareType = {
  id: number;
  displayValue: string;
  type?: FareTypeEnum
}

export type LoginResponse = {
  sessionId: string;
  routeSummaries: RouteSummary[];
  predefinedMessages: PredefinedMessage[];
  fareTypes: FareType[];
  paraPassEnabled: boolean;
  flagStopsEnabled: boolean;
  logVerbosity: number;
  daysRemainingBeforeUpgradeIsRequired: number;
  playStoreUpgradeNeeded: boolean;
  snapshotUpgradeNeeded: boolean;
  expirationNotice?: string;
  upgradeMessage?: string;
  paraScopeGpsReportingInterval: number;
  paraScopeGpsReportingEndpoint: string;
  paraScopeGpsReportingEndpointToken: string;
  rapidPassEnabled: boolean;
  speedLockThreshold: number;
}
